module.exports = __webpack_public_path__ + "img/待审核.3bf8a293.png";